export enum BANNER_TYPE {
  maintenanceMode = 'maintenance',
  tradingGlobal = 'trading-global',
}

export enum BANNER_ACTIONS {
  close = 'close',
  continue = 'continue',
}
